"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSwitchWrapper = void 0;
var _SwitchWrapper = require("./SwitchWrapper");
// TODO: in v9, move styled() from SwitchWrapper.jsx to here
var StyledSwitchWrapper = _SwitchWrapper.SwitchWrapper;
exports.StyledSwitchWrapper = StyledSwitchWrapper;